import _objectSpread from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import React from 'react';
import { useTheme } from '@mui/material';
import { observer } from 'mobx-react';
import { Axis, LEFT, RIGHT } from 'react-d3-axis-mod';
export default observer(function (_ref) {
  var model = _ref.model,
    orientation = _ref.orientation;
  var ticks = model.ticks;
  var theme = useTheme();
  return ticks ? React.createElement(Axis, _objectSpread({}, ticks, {
    shadow: 2,
    format: function format(n) {
      return n;
    },
    style: {
      orient: orientation === 'left' ? LEFT : RIGHT
    },
    bg: theme.palette.background.default,
    fg: theme.palette.text.primary
  })) : null;
});